export default {
    _Groups: {
        Extensiones: 'Extensiones'
    }
}